import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Icon } from '../Icon';
import classNames from 'classnames';
export const Checkbox = forwardRef(({ children, id, value, onChange, name, color = 'secondary', size, checked, disabled, className = '' }, ref) => {
    const labelClassName = classNames('flex items-center gap-2 group w-fit', checked ? 'font-bold' : 'font-medium', disabled ? 'text-gray' : 'text-gray-700 cursor-pointer', {
        'text-mBase md:text-base': !size,
        'text-sm': size === 'sm',
        'text-base': size === 'md',
        'text-mBase': size === 'lg'
    }, className);
    const iconClassName = classNames('flex-none border rounded', disabled && !checked ? 'text-gray-100' : 'text-white', {
        'w-5 h-5 md:w-4 md:h-4': !size,
        'w-4 h-4': size === 'sm' || size === 'md',
        'w-5 h-5': size === 'lg',
        'bg-white border-gray-400 group-hover:border-gray': !disabled && !checked,
        'bg-gray border-gray': disabled && checked,
        'bg-gray-100': disabled && !checked,
        'bg-blue border-blue': !disabled && checked && color === 'blue',
        'bg-secondary border-secondary': !disabled && checked && color === 'secondary'
    });
    const inputClassName = classNames(iconClassName, { 'cursor-pointer': !disabled }, 'absolute opacity-0 peer');
    return (_jsxs("label", { className: labelClassName, htmlFor: id, children: [_jsx("input", { checked: checked, className: inputClassName, "data-testid": `checkbox_${checked ? 'enabled' : 'disabled'}`, disabled: disabled, id: id, name: name, ref: ref, type: "checkbox", value: value, onChange: onChange }), _jsx(Icon, { className: iconClassName, name: "check" }), children] }));
});
